import React from "react";
import DefaultEditor from "react-simple-wysiwyg";

const TextEditor = ({ value, onChange }) => {
  const handleEditorChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <label className="fs-6">
        Event Description <span className="login-danger">*</span>
      </label>
      <DefaultEditor value={value} onChange={handleEditorChange} />
    </div>
  );
};

export default TextEditor;

